// import React, { useState, useEffect } from 'react';
// import { Container, Button, Form } from 'react-bootstrap';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';

// const BankDetailsForm = () => {
//   const BaseUrl = process.env.REACT_APP_API;
//   const navigate = useNavigate();
//   const [bankAccounts, setBankAccounts] = useState([]);

//   useEffect(() => {
//     const fetchBankAccounts = async () => {
//       try {
//         const jwtToken = sessionStorage.getItem("authToken");
//         if (!jwtToken) {
//           throw new Error("JWT token not found in local storage");
//         }

//         const tokenValidationResponse = await axios.post(
//           `${BaseUrl}/validate-token`,
//           { token: jwtToken }
//         );
//         if (!tokenValidationResponse.data.valid) {
//           throw new Error("Token validation failed or expired");
//         }

//         const response = await axios.get(`${BaseUrl}/getBankaccounts`, {
//           headers: {
//             Authorization: `Bearer ${jwtToken}`,
//           },
//         });
//         setBankAccounts(response.data);
//       } catch (error) {
//         console.error(error.message || "Error fetching bank accounts");
//       }
//     };

//     fetchBankAccounts();
//   }, [BaseUrl]);

//   const handleSubmit = () => {
//     navigate("/dashboard");
//   };


//   return (
//     <Container className="mt-5">
//       <Form>
//         <fieldset style={{ padding: "20px", display: "block" }}>
//           <div
//             style={{
//               padding: "20px",
//               borderRadius: "10px",
//               boxShadow: "0px 0px 20px #748292",
//               transition: "all 0.5s ease-in-out",
//             }}
//           >
//             <h6 className="text-start" style={{ marginBottom: "0.5rem" }}>
//               Bank Details
//             </h6>
//             <hr style={{ margin: "5px", border: "1px solid #748292", width: "100%" }} />

//             {bankAccounts.length > 0 ? (
//               bankAccounts.map((account, index) => (
//                 <div key={index}>
//                   <h6>Bank Account {index + 1}</h6>
//                   {/* Name of Bank */}
//                   <div className="row mb-3">
//                     <label className="col-md-3 col-form-label text-start">Name of Bank</label>
//                     <div className="col-md-9">
//                       <input
//                         type="text"
//                         className="form-control shadow-sm"
//                         placeholder="Enter the name of the bank"
//                         value={account.bank_name || ''}
//                         readOnly
//                       />
//                     </div>
//                   </div>

//                   {/* Account Name */}
//                   <div className="row mb-3">
//                     <label className="col-md-3 col-form-label text-start">Account Name</label>
//                     <div className="col-md-9">
//                       <input
//                         type="text"
//                         className="form-control shadow-sm"
//                         placeholder="Enter the account name"
//                         value={account.account_name || ''}
//                         readOnly
//                       />
//                     </div>
//                   </div>

//                   {/* Account Number */}
//                   <div className="row mb-3">
//                     <label className="col-md-3 col-form-label text-start">Account Number</label>
//                     <div className="col-md-9">
//                       <input
//                         type="text"
//                         className="form-control shadow-sm"
//                         placeholder="Enter the account number"
//                         value={account.account_number || ''}
//                         readOnly
//                       />
//                     </div>
//                   </div>

//                   {/* IBAN */}
//                   <div className="row mb-3">
//                     <label className="col-md-3 col-form-label text-start">IBAN</label>
//                     <div className="col-md-9">
//                       <input
//                         type="text"
//                         className="form-control shadow-sm"
//                         placeholder="Enter the IBAN"
//                         value={account.iban || ''}
//                         readOnly
//                       />
//                     </div>
//                   </div>

//                   {/* SWIFT */}
//                   <div className="row mb-3">
//                     <label className="col-md-3 col-form-label text-start">SWIFT</label>
//                     <div className="col-md-9">
//                       <input
//                         type="text"
//                         className="form-control shadow-sm"
//                         placeholder="Enter the SWIFT code"
//                         value={account.swift || ''}
//                         readOnly
//                       />
//                     </div>
//                   </div>
//                 </div>
//               ))
//             ) : (
              
//               <h6>No Bank Details Added</h6>
//             )}

//             {/* Submit Button */}
//             {/* <div className="text-end">
//               <button type="submit" className="btn btn-primary" onClick={handleSubmit}>
//                 Submit
//               </button>
//             </div> */}
//           </div>
//         </fieldset>
//       </Form>
//     </Container>
//   );
// };

// export default BankDetailsForm;
import React, { useState, useEffect } from 'react';
import { Container, Button, Form, Modal } from 'react-bootstrap';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from "react-toastify";


const BankDetailsForm = () => {
  const BaseUrl = process.env.REACT_APP_API;
  const navigate = useNavigate();
  const [countries, setCountries] = useState([]);
  const [bankAccounts, setBankAccounts] = useState([]);
  const [editingIndex, setEditingIndex] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const initialFormState = {
    bank_name: "",
    address_1: "",
    address_2: "",
    country: "",
    city: "",
    account_name: "",
    account_number: "",
    iban: "",
    swift: "",
  };

  const [formState, setFormState] = useState(initialFormState);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await fetch(`${BaseUrl}/countries`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setCountries(data);
      } catch (error) {
        console.error("Failed to fetch countries:", error);
      }
    };

    fetchCountries();
  }, [BaseUrl]);

  useEffect(() => {
    const validateToken = async () => {
      try {
        const jwtToken = sessionStorage.getItem("authToken");
        if (!jwtToken) {
          throw new Error("JWT token not found in session storage");
        }

        const response = await axios.post(`${BaseUrl}/validate-token`, {
          token: jwtToken,
        });
        if (!response.data.valid) {
          throw new Error("Token validation failed");
        }
      } catch (error) {
        console.error("Error validating token:", error);
        navigate("/onboarding");
      }
    };

    validateToken();
  }, []);


    const fetchBankAccounts = async () => {
      setLoading(true);
      try {
        const jwtToken = sessionStorage.getItem("authToken");
        if (!jwtToken) {
          setLoading(false);
          throw new Error("JWT token not found in session storage");
        }

        const tokenValidationResponse = await axios.post(
          `${BaseUrl}/validate-token`,
          { token: jwtToken }
        );
        if (!tokenValidationResponse.data.valid) {
          setLoading(false);
          throw new Error("Token validation failed or expired");
        }

        const response = await axios.get(`${BaseUrl}/getBankaccounts`, {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        });
        setLoading(false);
        setBankAccounts(response.data);
      } catch (error) {
        console.error(error.message || "Error fetching bank accounts");
        setLoading(false);
      }
    };

    useEffect(() => {

    fetchBankAccounts();
  }, [BaseUrl]);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleAddBankAccount = async () => {
    // Check if any required field is empty
    if (
      !formState.bank_name ||
      !formState.address_1 ||
      !formState.country ||
      !formState.city ||
      !formState.account_name ||
      !formState.account_number ||
      !formState.iban ||
      !formState.swift
    ) {
      toast.error("Please fill out all required fields.");
      return;
    }
  
    try {
      const jwtToken = sessionStorage.getItem("authToken");
      if (!jwtToken) {
        throw new Error("JWT token not found in session storage");
      }
  
      // Prepare the data to submit - always send as an array
      const accountsToSubmit = editingIndex !== null 
        ? bankAccounts.map((account, index) => 
            index === editingIndex ? formState : account
          )
        : [...bankAccounts, formState];
  
      // Validate token first
      const tokenValidationResponse = await axios.post(
        `${BaseUrl}/validate-token`,
        { token: jwtToken }
      );
      if (!tokenValidationResponse.data.valid) {
        throw new Error("Token validation failed or expired");
      }
  
      // Submit all bank accounts including the new/updated one
      const response = await axios.post(
        `${BaseUrl}/submitBankaccounts`,
        accountsToSubmit,
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            "Content-Type": "application/json",
          },
        }
      );
  
      // Update local state with the response data
      setBankAccounts(response.data);
      
      if (editingIndex !== null) {
        toast.success("Bank account updated successfully!");
        setEditingIndex(null);
      } else {
        toast.success("Bank account added successfully!");
      }
      fetchBankAccounts();
  
      setFormState(initialFormState);
      setShowModal(false);
    } catch (error) {
      console.error("Error saving bank account:", error);
      toast.error("Failed to save bank account");
    }
  };

  const handleEditBankAccount = (index) => {
    setFormState(bankAccounts[index]);
    setEditingIndex(index);
    setShowModal(true);
  };

  const handleDeleteBankAccount = async (index) => {
    try {
      const jwtToken = sessionStorage.getItem("authToken");
      if (!jwtToken) {
        throw new Error("JWT token not found in session storage");
      }

      const accountToDelete = bankAccounts[index];
      
      // If the account has an ID (meaning it exists in the backend), delete it from backend first
      if (accountToDelete.id) {
        await axios.delete(`${BaseUrl}/deleteBankaccount/${accountToDelete.id}`, {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        });
      }

      // Then remove it from the frontend state
      const updatedBankAccounts = [...bankAccounts];
      updatedBankAccounts.splice(index, 1);
      setBankAccounts(updatedBankAccounts);
      
      toast.success("Bank account deleted successfully!");
    } catch (error) {
      console.error("Error deleting bank account:", error);
      toast.error("Failed to delete bank account");
    }
  };

  const handleSubmitAll = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const jwtToken = sessionStorage.getItem("authToken");
      if (!jwtToken) {
        setLoading(false);
        throw new Error("JWT token not found in session storage");
      }

      const tokenValidationResponse = await axios.post(
        `${BaseUrl}/validate-token`,
        { token: jwtToken }
      );
      if (!tokenValidationResponse.data.valid) {
        setLoading(false);
        throw new Error("Token validation failed or expired");
      }

      await axios.post(`${BaseUrl}/submitBankaccounts`, bankAccounts, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          "Content-Type": "application/json",
        },
      });
      setLoading(false);
      toast.success("Bank Accounts Submitted Successfully!");
      navigate("/dashboard");
    } catch (err) {
      console.error("Error submitting the form:", err);
      toast.error("Failed to submit bank accounts");
      setLoading(false);
    }
  };

  const handleResetForm = () => {
    setFormState(initialFormState);
    setEditingIndex(null);
    setShowModal(false);
  };

  const openAddModal = () => {
    setFormState(initialFormState);
    setEditingIndex(null);
    setShowModal(true);
  };

  const getCountryName = (countryId) => {
    const country = countries.find(c => c.NumCode == countryId);
    return country ? country.Country : countryId;
  };

  return (
    <Container className="mt-5">
      <Form onSubmit={handleSubmitAll}>
        <fieldset style={{ padding: "20px", display: "block" }}>
          <div
            style={{
              padding: "20px",
              borderRadius: "10px",
              boxShadow: "0px 0px 20px #748292",
              transition: "all 0.5s ease-in-out",
            }}
          >
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h6 className="text-start" style={{ marginBottom: "0.5rem" }}>
                Bank Details
              </h6>
              <Button variant="primary" size="sm" onClick={openAddModal}>
                Add Bank Account
              </Button>
            </div>
            <hr style={{ margin: "5px", border: "1px solid #748292", width: "100%" }} />

            {/* Display Existing Bank Accounts */}
            {bankAccounts.length > 0 ? (
              bankAccounts.map((account, index) => (
                <div key={index} className="mb-4 p-3" style={{ border: "1px solid #dee2e6", borderRadius: "5px" }}>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <h6>Bank Account {index + 1}</h6>
                    {/* <div>
                      <Button 
                        variant="outline-primary" 
                        size="sm" 
                        className="me-2"
                        onClick={() => handleEditBankAccount(index)}
                      >
                        Edit
                      </Button>
                      <Button 
                        variant="outline-danger" 
                        size="sm"
                        onClick={() => handleDeleteBankAccount(index)}
                      >
                        Delete
                      </Button>
                    </div> */}
                  </div>

                  {/* Name of Bank */}
                  <div className="row mb-3">
                    <label className="col-md-3 col-form-label text-start">Name of Bank</label>
                    <div className="col-md-9">
                      <input
                        type="text"
                        className="form-control shadow-sm"
                        value={account.bank_name || ''}
                        readOnly
                      />
                    </div>
                  </div>

                  {/* Address */}
                  <div className="row mb-3">
                    <label className="col-md-3 col-form-label text-start">Address</label>
                    <div className="col-md-9">
                      <input
                        type="text"
                        className="form-control shadow-sm"
                        value={`${account.address_1}${account.address_2 ? `, ${account.address_2}` : ''}, ${account.city}, ${getCountryName(account.country)}`}
                        readOnly
                      />
                    </div>
                  </div>

                  {/* Account Name */}
                  <div className="row mb-3">
                    <label className="col-md-3 col-form-label text-start">Account Name</label>
                    <div className="col-md-9">
                      <input
                        type="text"
                        className="form-control shadow-sm"
                        value={account.account_name || ''}
                        readOnly
                      />
                    </div>
                  </div>

                  {/* Account Number */}
                  <div className="row mb-3">
                    <label className="col-md-3 col-form-label text-start">Account Number</label>
                    <div className="col-md-9">
                      <input
                        type="text"
                        className="form-control shadow-sm"
                        value={account.account_number || ''}
                        readOnly
                      />
                    </div>
                  </div>

                  {/* IBAN */}
                  <div className="row mb-3">
                    <label className="col-md-3 col-form-label text-start">IBAN</label>
                    <div className="col-md-9">
                      <input
                        type="text"
                        className="form-control shadow-sm"
                        value={account.iban || ''}
                        readOnly
                      />
                    </div>
                  </div>

                  {/* SWIFT */}
                  <div className="row mb-3">
                    <label className="col-md-3 col-form-label text-start">SWIFT</label>
                    <div className="col-md-9">
                      <input
                        type="text"
                        className="form-control shadow-sm"
                        value={account.swift || ''}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="text-center py-4">
                <h6>No Bank Details Added</h6>
              </div>
            )}

            {/* Submit Button */}
            {/* {bankAccounts.length > 0 && (
              <div className="text-end mt-4">
                <Button 
                  type="submit" 
                  variant="primary" 
                  disabled={loading}
                >
                  {loading ? 'Submitting...' : 'Submit Bank Details'}
                </Button>
              </div>
            )} */}
          </div>
        </fieldset>
      </Form>

      {/* Add/Edit Modal */}
      <Modal show={showModal} onHide={handleResetForm} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{editingIndex !== null ? `Edit Bank Account ${editingIndex + 1}` : "Add New Bank Account"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {/* Bank Name */}
            <div className="row mb-3">
              <label htmlFor="bank_name" className="col-md-3 col-form-label text-start">Name of Bank*</label>
              <div className="col-md-9">
                <input
                  id="bank_name"
                  type="text"
                  className="form-control shadow-sm"
                  placeholder="Enter the name of the bank"
                  value={formState.bank_name}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            {/* Address 1 */}
            <div className="row mb-3">
              <label htmlFor="address_1" className="col-md-3 col-form-label text-start">Address Line 1*</label>
              <div className="col-md-9">
                <input
                  id="address_1"
                  type="text"
                  className="form-control shadow-sm"
                  placeholder="Enter address line 1"
                  value={formState.address_1}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            {/* Address 2 */}
            <div className="row mb-3">
              <label htmlFor="address_2" className="col-md-3 col-form-label text-start">Address Line 2</label>
              <div className="col-md-9">
                <input
                  id="address_2"
                  type="text"
                  className="form-control shadow-sm"
                  placeholder="Enter address line 2"
                  value={formState.address_2}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* Country */}
            <div className="row mb-3">
              <label htmlFor="country" className="col-md-3 col-form-label text-start">Country*</label>
              <div className="col-md-9">
                <select
                  id="country"
                  className="form-control shadow-sm"
                  value={formState.country}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Country</option>
                  {countries.map((country) => (
                    <option key={country.NumCode} value={country.NumCode}>
                      {country.Country}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* City */}
            <div className="row mb-3">
              <label htmlFor="city" className="col-md-3 col-form-label text-start">City*</label>
              <div className="col-md-9">
                <input
                  id="city"
                  type="text"
                  className="form-control shadow-sm"
                  placeholder="Enter city"
                  value={formState.city}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            {/* Account Name */}
            <div className="row mb-3">
              <label htmlFor="account_name" className="col-md-3 col-form-label text-start">Account Name*</label>
              <div className="col-md-9">
                <input
                  id="account_name"
                  type="text"
                  className="form-control shadow-sm"
                  placeholder="Enter the account name"
                  value={formState.account_name}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            {/* Account Number */}
            <div className="row mb-3">
              <label htmlFor="account_number" className="col-md-3 col-form-label text-start">Account Number*</label>
              <div className="col-md-9">
                <input
                  id="account_number"
                  type="text"
                  className="form-control shadow-sm"
                  placeholder="Enter the account number"
                  value={formState.account_number}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            {/* IBAN */}
            <div className="row mb-3">
              <label htmlFor="iban" className="col-md-3 col-form-label text-start">IBAN*</label>
              <div className="col-md-9">
                <input
                  id="iban"
                  type="text"
                  className="form-control shadow-sm"
                  placeholder="Enter the IBAN"
                  value={formState.iban}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            {/* SWIFT */}
            <div className="row mb-3">
              <label htmlFor="swift" className="col-md-3 col-form-label text-start">SWIFT Code*</label>
              <div className="col-md-9">
                <input
                  id="swift"
                  type="text"
                  className="form-control shadow-sm"
                  placeholder="Enter the SWIFT code"
                  value={formState.swift}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleResetForm}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleAddBankAccount}>
            {editingIndex !== null ? "Update Account" : "Add Account"}
          </Button>
        </Modal.Footer>
      </Modal>
      <ToastContainer position="top-right" autoClose={3000} />

    </Container>
    
  );
};

export default BankDetailsForm;